import MiniBars from "./MiniBars";

type RampCardProps = {
  title: string;
  subtitle: string;
  series: number[];
  active?: boolean;
  onSelect: () => void;
  color: "green" | "orange" | "blue";
  scale?: { min: number; max: number };
};

export default function RampCard({
  title,
  subtitle,
  series,
  active,
  onSelect,
  color,
  scale,
}: RampCardProps) {
  const colorStyles = {
    green: {
      activeBorder: "border-green-600",
      activeRing: "ring-green-500/30",
      activeBg: "bg-green-50",
      focusRing: "focus-visible:ring-green-500",
    },
    orange: {
      activeBorder: "border-orange-600",
      activeRing: "ring-orange-500/30",
      activeBg: "bg-orange-50",
      focusRing: "focus-visible:ring-orange-500",
    },
    blue: {
      activeBorder: "border-[hsl(215_85%_45%)]",
      activeRing: "ring-[hsl(215_85%_45%)]/30",
      activeBg: "bg-[hsl(215_85%_96%)]",
      focusRing: "focus-visible:ring-[hsl(215_85%_45%)]",
    },
  };

  const styles = colorStyles[color];

  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={active}
      className={[
        "w-full text-left rounded-xl border shadow-sm transition-all duration-200 h-full",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        styles.focusRing,
        active
          ? `${styles.activeBorder} ring-2 ${styles.activeRing} ${styles.activeBg}`
          : "border-slate-200 hover:border-slate-300 bg-white hover:shadow-md",
      ].join(" ")}
    >
      <div className="p-4 h-full flex flex-col">
        <div className="mb-3">
          <div
            className={`text-sm font-semibold ${
              active && color === "blue"
                ? "text-[hsl(215_85%_45%)]"
                : "text-slate-900"
            }`}
          >
            {title}
          </div>
          <div className="text-xs text-slate-600 mt-1">{subtitle}</div>
        </div>
        <div className="mt-auto">
          <MiniBars values={series} color={color} scale={scale} />
        </div>
      </div>
    </button>
  );
}
